import { useMatchMedia } from './useMatchMedia';
function isResponsiveProp(prop) {
    if (prop != null &&
        typeof prop === 'object' &&
        Object.keys(prop).some((propKey) => ['extraSmall', 'small', 'medium', 'large', 'base'].includes(propKey))) {
        return true;
    }
    return false;
}
export function useResponsiveProp(prop, defaultValue) {
    var _a;
    const media = new Map([
        ['extraSmall', useMatchMedia('to-extra-small')],
        ['small', useMatchMedia('to-small')],
        ['medium', useMatchMedia('to-medium')],
        ['large', useMatchMedia('to-large')],
    ]);
    media.set('base', [...media.values()].every((match) => match === false));
    return ((_a = (isResponsiveProp(prop)
        ? [...media.entries()].reduceRight((matchedProp, [size, match]) => {
            var _a;
            const nextMatchedProp = (_a = prop[size]) !== null && _a !== void 0 ? _a : matchedProp;
            if (match && typeof nextMatchedProp !== 'undefined') {
                return nextMatchedProp;
            }
            return matchedProp;
        }, prop.base)
        : prop)) !== null && _a !== void 0 ? _a : defaultValue);
}
//# sourceMappingURL=useResponsiveProp.js.map